"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSlugifyDictionary = exports.buildInstallationTypeObject = exports.buildObject = exports.buildSlugifyObject = exports.slugifyTitle = exports.slugify = exports.capitalizeString = void 0;
// DON"T REMOVE - USED Server Side - Exported in 'lib/helpers'
const capitalizeString = (str) => {
    return Boolean(str)
        ? `${str}`.replace(/[\wÀ-ÿ]+/g, (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        : '';
};
exports.capitalizeString = capitalizeString;
// slugify('This WorKing') => 'this-working'
const slugify = (str) => String(str || '')
    .replace(/[^a-z0-9]/gi, '-')
    .toLowerCase()
    .replace(/-{2,}/g, '-') // Remove Multiple '-': 'this-is---a-link' => 'this-is-a-link'
    .replace(/^-/, '') // Remove Starting `-`
    .replace(/-$/, '');
exports.slugify = slugify;
// Remove Trailing '-'
const slugifyTitle = (str) => (0, exports.slugify)(str)
    .split('-')
    .filter(Boolean)
    .map((string) => (0, exports.capitalizeString)(string))
    .join('-');
exports.slugifyTitle = slugifyTitle;
// Expects a object => { "Abstract": 897, "Fine Art": 638, "Abstract Expressionism": 450, ... }
// Will return a new Object => { abstract: "Abstract", "fine-art", "Fine Art", "abstract-expressionism": "Abstract Expressionism", ... }
const buildSlugifyObject = (obj) => Object.keys(obj).reduce((results, key) => (Object.assign(Object.assign({}, results), { [(0, exports.slugify)(key)]: key })), {});
exports.buildSlugifyObject = buildSlugifyObject;
const buildObject = (obj) => Object.keys(obj).reduce((results, key) => (Object.assign(Object.assign({}, results), { [key]: key })), {});
exports.buildObject = buildObject;
// Special mapping for installation_type facet values
const buildInstallationTypeObject = (obj) => {
    const installationTypeMapping = {
        wall_mounted: 'wall-mounted',
        free_standing: 'free-standing',
    };
    return Object.keys(obj).reduce((results, key) => {
        const mappedKey = installationTypeMapping[key] || key;
        return Object.assign(Object.assign({}, results), { [mappedKey]: key });
    }, {});
};
exports.buildInstallationTypeObject = buildInstallationTypeObject;
// Expects a object => { facets: { "Abstract": 897, "Fine Art": 638, "Abstract Expressionism": 450, ... } }
// Will return a new Object => { facets: { abstract: "Abstract", "fine-art", "Fine Art", "abstract-expressionism": "Abstract Expressionism", ... } }
const buildSlugifyDictionary = (obj) => Object.entries(obj).reduce((results, [key, value]) => {
    if (key.search(/curated_status/) > -1) {
        // Skip these values - do NOT slugify
        return Object.assign(Object.assign({}, results), { [key]: (0, exports.buildObject)(value) });
    }
    else if (key === 'installation_type') {
        // Use custom mapping for installation_type
        return Object.assign(Object.assign({}, results), { [key]: (0, exports.buildInstallationTypeObject)(value) });
    }
    else {
        return Object.assign(Object.assign({}, results), { [key]: (0, exports.buildSlugifyObject)(value) });
    }
}, {});
exports.buildSlugifyDictionary = buildSlugifyDictionary;
module.exports = {
    buildSlugifyDictionary: exports.buildSlugifyDictionary,
    buildSlugifyObject: exports.buildSlugifyObject,
    capitalizeString: exports.capitalizeString,
    slugify: exports.slugify,
    slugifyTitle: exports.slugifyTitle,
};
